






































import { type PropType, defineComponent } from "vue-demi";
import type {
  CategoryNested,
  PageDataPropUnion,
  ProductModel,
} from "@constructor/shared-entity/type";
import getValueForProp from "../../../helper/getValueForProp";
import { formatPrice } from "@artmizu/utils";

export default defineComponent({
  name: "GGPhoneGrid",
  props: {
    list: {
      type: Array as PropType<CategoryNested[] | ProductModel[]>,
      default: () => [],
    },
    prop: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
  },
  computed: {
    count() {
      return this.list.length >= 5 ? 5 : 4;
    },
    link() {
      return getValueForProp("otherCategoriesLink", this.prop) || undefined;
    },
    title() {
      return getValueForProp("otherCategoriesTitle", this.prop) || undefined;
    },
  },
  methods: {
    formatPrice(price: number) {
      return formatPrice(price);
    },
  },
});
